export default function OrganizationActionBar({
  onCreateClick,
  onLeaveClick,
  onDeleteClick,
  selectedCount,
}) {
  const hasSelection = selectedCount > 0
  const canDelete = typeof onDeleteClick === "function"

  return (
    <div className="organization-action-bar">
      <div className="organization-action-bar__buttons">
        <button type="button" onClick={onCreateClick}>
          Create organization
        </button>
        <button
          type="button"
          className="button--danger"
          onClick={onLeaveClick}
          disabled={!hasSelection}
        >
          {hasSelection
            ? `Leave selected (${selectedCount})`
            : "Leave selected"}
        </button>
        {canDelete && (
          <button
            type="button"
            className="button--danger"
            onClick={onDeleteClick}
            disabled={!hasSelection}
          >
            {hasSelection
              ? `Delete selected (${selectedCount})`
              : "Delete selected"}
          </button>
        )}
      </div>
      <p className="organization-action-bar__helper">
        {canDelete
          ? "Select organizations to leave or delete, or create a new one."
          : "Select organizations to leave or create a new one."}
      </p>
    </div>
  )
}
